module.exports = __webpack_public_path__ + "static/media/imageC.68076588.png";